import { Component, OnInit } from '@angular/core';
declare let $: any;
@Component({
  selector: 'app-expenses',
  templateUrl: './expenses.component.html',
  styleUrls: ['./expenses.component.scss']
})
export class ExpensesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  expenseDetails(): void
  {
    $('#expense_details').modal('show');
  }
}
